module.exports = __webpack_public_path__ + "static/media/amallogo.8a48e0b3.png";